export const style = {
  h2: {
    fontSize: `32px`,
    fontWeight: 300,
    color: `black`,
    margin: `0 0 32px 0`
  },
  h4: {
    fontSize: `22px`,
    fontWeight: 300,
    color: `black`,
    margin: `0 0 32px 0`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/User/style/headers.js